class MultiError extends Error {
    constructor(errors, ...params) {
      // Pass remaining arguments (including vendor specific ones) to parent constructor
      super(...params)
  
      // Maintains proper stack trace for where our error was thrown (only available on V8)
      if (Error.captureStackTrace) {
        Error.captureStackTrace(this, MultiError)
      }
  
      this.name = 'MultiError'
      // Custom debugging information
      this.errors = errors
      this.date = new Date()
    }
  }

export default MultiError;  